import '../../../styles/templates/account.pcss';

import {Pager} from '../../ui/pager';
import '../../ui/pager/pager.pcss';

import {Toggle} from '../../ui/toggle';

new Pager();

const accountNavToggle = document.querySelector(
  '[data-account-nav-toggle]'
);

if (accountNavToggle) {
  new Toggle(accountNavToggle);
}
